import vuetify from "@/main";
import MaxioCompanySubscription from '@/modules/settings/subscription/MaxioSubbscription/MaxioCompanySubscription.vue';
angular.module('leanlaw').config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
  $urlRouterProvider.otherwise("/");
  $stateProvider.state("home", {
    url: "/",
    controller: ['$state', 'userService', function ($state, userService) {
      userService.me().then(me => {
        if ($state.current.name === 'home') {
          $state.go((me.settings ? me.settings.startState : null) || 'timeplanner');
        }
      });
    }]
  }).state("launch", {
    url: "/launch",
    template: "<div></div>",
    controller: ['$state', 'userService', function ($state, userService) {
      userService.me().then(me => {
        $state.go('timeentries', {
          'new': true
        });
      });
    }]
  }).state("demo", {
    url: "/demo",
    template: "<div></div>",
    controller: ['$state', '$window', function ($state, $window) {
      $window.open("https://www.leanlaw.co/request-a-live-demo/");
      $state.go("home");
    }]
  }).state('maxio', {
    url: "/maxio-subscription",
    params: {
      isSmallScreen: true
    },
    views: {
      subscription: {
        ...vuetify(MaxioCompanySubscription)
      }
    }
  });
}]);